// *******************************************************************************
// Tabs Module
// *******************************************************************************

// Active Class Remove
const removeFormTabActiveClass = (parentElem) => {
  const navLinks = parentElem.querySelectorAll('.tabs-module__tabs-link.is-active');
  const tabPanels = parentElem.querySelectorAll('.tabs-module__content.is-active');
  const activeItems = [...navLinks, ...tabPanels];
  activeItems.forEach((elem) => {
    elem.classList.remove('is-active');
  });
};

// Active Class Toggle
attachEvent('.tabs-module__tabs-link', 'click', (ev) => {
  const button = ev.target;
  const parentElem = button.closest('.tabs-module');
  const tabId = button.getAttribute('aria-controls');
  const dropdownEle = parentElem.querySelector('.tabs-module__tabs-wrapper');
  const placeholderText = parentElem.querySelector('.tabs-module__tabs-trigger-text');
  const buttonText = button.querySelector('.tabs-module__tabs-link-text').innerHTML;
  const panelElement = parentElem.querySelector(`#${tabId}`);
  removeFormTabActiveClass(parentElem);
  button.classList.add('is-active');
  panelElement.classList.add('is-active');
  placeholderText.innerHTML = buttonText;
  dropdownEle.classList.remove('is-open');
  ev.preventDefault();
});

// Open Dropdown - Mobile
attachEvent('.tabs-module__tabs-trigger', 'click', (ev) => {
  const parentEle = ev.target.closest('.tabs-module__tabs-wrapper');
  parentEle.classList.toggle('is-open');
});

// Replace Active Text On Load
document.addEventListener('DOMContentLoaded', () => {
  const tabsModule = document.querySelectorAll('.tabs-module');
  tabsModule.forEach((ele) => {
    const activeTabLink = ele.querySelector('.tabs-module__tabs-link.is-active');
    if (activeTabLink) {
      const activeTabText = activeTabLink.querySelector('.tabs-module__tabs-link-text').innerHTML;
      const placeholderText = ele.querySelector('.tabs-module__tabs-trigger-text');
      placeholderText.innerHTML = activeTabText;
    }
  });
});

// Close on click outside
document.addEventListener('click', (ev) => {
  const tabsDropdown = document.querySelectorAll('.tabs-module__tabs-wrapper');

  tabsDropdown.forEach((dropdown) => {
    const clickInside = dropdown.contains(ev.target);
    if (!clickInside) {
      dropdown.classList.remove('is-open');
    }
  });
});
